import { FC, useEffect, useState } from "react";
import { useFormContext, useFormState } from "react-hook-form";
import { AlertTriangle } from "lucide-react";
import { useAzureFileUpload } from "src/components/AssetUploaders/useAzureFileUpload";
import VideoUpload from "./VideoUpload";
import get from "lodash.get";

interface Props {
	stepNumber: number;
}

const VideoUploadStep: FC<Props> = ({ stepNumber }) => {
	const { control, setValue } = useFormContext<BannerFormState>();

	const [uuid, setUUID] = useState<string | null>(null);

	const { done, error, uploading, upload } = useAzureFileUpload((uuidList) => {
		if (!uuidList) return;

		if (!Array.isArray(uuidList)) {
			setUUID(uuidList);
		}
	});

	const { errors } = useFormState({ control });

	const isAnswerInvalid =
		Boolean(get(errors, `steps[${stepNumber - 1}]`, null)) || error;

	useEffect(() => {
		setValue(`steps.${stepNumber - 1}.error`, error);
	}, [error]);

	useEffect(() => {
		setValue(`steps.${stepNumber - 1}.uploading`, uploading);
	}, [uploading]);

	return (
		<div>
			{error && (
				<div className="flex items-center gap-1.5 text-destructive mb-3">
					<AlertTriangle size={16} />
					<span className="text-sm">
						Problem uploading the video. Please try again.
					</span>
				</div>
			)}

			<div
				className={
					isAnswerInvalid || error
						? "rounded-lg border border-destructive p-2"
						: ""
				}
			>
				<VideoUpload
					stepNumber={stepNumber}
					placeholder="Upload video"
					control={control}
					error={error}
					upload={upload}
					uuid={uuid}
					done={done}
					uploading={uploading}
					setValue={setValue}
				/>
			</div>
		</div>
	);
};

export default VideoUploadStep;
